// NFR-5679 中断データスキーマバージョン
const BREAK_DATA_VERSION = {
	VERSION1: 1, 
	VERSION2: 2, 
}

// NFR-5679 最新中断データスキーマバージョン取得
const getLatestBreakDataVersion = () => {
    return Math.max(...Object.values(BREAK_DATA_VERSION));
};

export {BREAK_DATA_VERSION, getLatestBreakDataVersion}